import { render, staticRenderFns } from "./OfferCreatorWelcome.vue?vue&type=template&id=5f5265a2&"
import script from "./OfferCreatorWelcome.vue?vue&type=script&lang=js&"
export * from "./OfferCreatorWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports